'use strict';

var Collection = require('base/Colido.Collection');
var ModalModel = require('../models/modal');

/**
 * Collection for maintaining modal windows
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var ModalsCollection = Collection.extend({
    model: ModalModel,
    name: 'global:modals',
});

module.exports = ModalsCollection;